import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js'
import { TYPE_LABEL_MAP } from './button_utils.js'

const TYPE_OPTIONS = [
  { value: 'view', label: TYPE_LABEL_MAP.view },
  { value: 'click', label: TYPE_LABEL_MAP.click },
  { value: 'miniprogram', label: TYPE_LABEL_MAP.miniprogram }
]

export default {
  name: 'MenuButtonDetails',

  components: {
    DropdownSelect
  },

  props: {
    button: {
      type: Object,
      default: null
    },
    clickButtons: {
      type: Array,
      default: () => []
    },
    limits: {
      type: Object,
      required: true
    },
    isRoot: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    hasSubButtons() {
      return this.button && this.button.sub_button && this.button.sub_button.length > 0
    },

    typeOptionGroups() {
      return [{ options: TYPE_OPTIONS }]
    },

    currentTypeOption() {
      if (!this.button) {
        return null
      }
      return TYPE_OPTIONS.find((option) => option.value === this.button.type) || TYPE_OPTIONS[0]
    },

    maxNameLengthHint() {
      const max = this.isRoot ? this.limits.max_menu_name_length : this.limits.max_submenu_name_length
      if (!max) {
        return null
      }
      const han = Math.floor(max / 2)
      return this.isRoot
        ? `一级菜单最多${han}个汉字或者${max}个字母`
        : `二级菜单最多${han}个汉字或${max}个字母`
    }
  },

  methods: {
    emitField(field, value) {
      this.$emit('update-field', { field, value })
    },

    onNameInput(event) {
      this.emitField('name', event.target.value)
      this.$emit('validate-name', event.target.value)
    },

    onTypeChange(option) {
      if (!option) {
        return
      }
      this.$emit('change-type', option.value)
    },

    onKeyBlur(event) {
      this.$emit('change-key', event.target.value)
    },

    resetDetails() {
      this.$emit('reset')
    }
  },

  template: `
    <div class="menu-button-details" v-if="button">
      <div class="form-field">
        <label class="form-label" for="menuNameInput">菜单名</label>
        <p class="helper-text" v-if="maxNameLengthHint">{{ maxNameLengthHint }}</p>
        <input
          id="menuNameInput"
          type="text"
          class="form-control"
          placeholder="菜单名"
          :value="button.name"
          @input="onNameInput"
        />
      </div>

      <template v-if="!hasSubButtons">
        <div class="form-field">
          <label class="form-label">类型</label>
          <dropdown-select
            :key="button._uid + '-' + button.type"
            custom-class="wechat-menu-type-select"
            :option-groups="typeOptionGroups"
            :init-value="currentTypeOption"
            @change="onTypeChange"
          >
            <template slot="value-template" slot-scope="{ option }">
              {{ option.label }}
            </template>
            <template slot="option-template" slot-scope="{ option }">
              {{ option.label }}
            </template>
          </dropdown-select>
        </div>

        <div class="form-field" v-if="button.type === 'view'">
          <label class="form-label" for="menuLinkInput">跳转链接</label>
          <p class="helper-text">点击菜单后要跳转到的页面地址（包含http/https）</p>
          <input
            id="menuLinkInput"
            type="text"
            class="form-control"
            placeholder="链接地址"
            :value="button.url"
            @input="emitField('url', $event.target.value)"
          />
        </div>

        <div class="form-field" v-else-if="button.type === 'click'">
          <label class="form-label">点击推事件</label>
          <p class="helper-text">
            <span>用户点击菜单后会带上 KEY 向服务器请求，可选择的有:</span><br />
            <template v-for="(item, index) in clickButtons">
              <span :key="'label-' + item.key">{{ index + 1 }}. {{ item.label }}: </span>
              <code :key="'code-' + item.key" class="menu-key-code">{{ item.key }}</code><br />
            </template>
            <span>以及自定义 KEY (建议配合<code>转发微信请求地址</code>)</span>
          </p>
          <input
            type="text"
            class="form-control"
            placeholder="执行命令"
            :value="button.key"
            @blur="onKeyBlur"
          />
        </div>

        <template v-else-if="button.type === 'miniprogram'">
          <div class="form-field">
            <label class="form-label" for="menuAppidInput">小程序的 appid（仅认证公众号可配置）</label>
            <input
              id="menuAppidInput"
              type="text"
              class="form-control"
              placeholder="appid"
              :value="button.appid"
              @input="emitField('appid', $event.target.value)"
            />
          </div>
          <div class="form-field">
            <label class="form-label" for="menuPagepathInput">小程序的页面路径</label>
            <input
              id="menuPagepathInput"
              type="text"
              class="form-control"
              placeholder="页面路径"
              :value="button.pagepath"
              @input="emitField('pagepath', $event.target.value)"
            />
          </div>
          <div class="form-field">
            <label class="form-label" for="menuMiniprogramUrlInput">跳转链接</label>
            <p class="helper-text">不支持小程序的老版本客户端将打开本链接</p>
            <input
              id="menuMiniprogramUrlInput"
              type="text"
              class="form-control"
              placeholder="链接地址"
              :value="button.url"
              @input="emitField('url', $event.target.value)"
            />
          </div>
        </template>
      </template>

      <div class="menu-button-details-actions">
        <button type="button" class="outlined btn-default" @click="resetDetails">重置</button>
      </div>
    </div>
    <p v-else class="menu-button-details-empty">当前未选中菜单!</p>
  `
}
